import { render, staticRenderFns } from "./MonthlyCalendar.vue?vue&type=template&id=a874dbf4&scoped=true&"
import script from "./MonthlyCalendar.vue?vue&type=script&lang=js&"
export * from "./MonthlyCalendar.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyCalendar.vue?vue&type=style&index=0&id=a874dbf4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a874dbf4",
  null
  
)

export default component.exports